/**
 * Pick the workspace to activate after login.
 *
 * Keep the workspace this browser was already using when the account still
 * belongs to it (multi-workspace users shouldn't be bounced to an arbitrary
 * one on every login); otherwise fall back to the server's first — oldest —
 * membership. Null when the account has no active workspaces, so a stale
 * foreign workspace id can't linger and 403 every subsequent call.
 */
export function pickWorkspaceId(
  stored: string | null,
  workspaces: ReadonlyArray<{ id: string }>,
): string | null {
  if (stored && workspaces.some((w) => w.id === stored)) return stored;
  return workspaces[0]?.id ?? null;
}
